import Logger from './Logger';

export { Logger };

export const renderPrice = (price: number): string => `$${new Intl.NumberFormat('en-US').format(price)}`;
